// format error, and any inner errors, kinda like console.error, but more comprehensive
// kinda like C# with inner Exceptions
export function formatError(error: unknown): string {
  // use this instead if we want an actual indent?
  // const indent = '  '.repeat(depth);
  const indent = '';

  if (error instanceof Error) {
    const main = error.stack ?? `${error.name}: ${error.message}`;
    const additional = getAdditionalInfo(error);
    return `${indent}${main}${additional ? '\n' + additional : ''}`;
  }

  if (typeof error === 'string') {
    return `${indent}${error}`;
  }

  try {
    return `${indent}${JSON.stringify(error)}`;
  } catch {
    return `${indent}${String(error)}`;
  }
}

// get extra info from the error in a formatted string
// ex: from AggregateError
export function getAdditionalInfo(error: Error): string | null {
  if (error instanceof AggregateError && error.errors.length > 0) {
    return error.errors
      .map((innerError, i) => {
        const errorId = i.toString();
        const prefix = `--- Inner error #${errorId} ---`;
        const suffix = `--- End of Inner error #${errorId} ---`;
        const formattedError = formatError(innerError);
        const indentedError = indentLines(formattedError, '| ');
        return `${prefix}\n${indentedError}\n${suffix}`;
      })
      .join('\n');
  }

  return null;
}

export function indentLines(str: string, indent: string): string {
  return str
    .split('\n')
    .map((value) => indent + value)
    .join('\n');
}

// log all errors, including inner errors from AggregateErrors
export function logAllErrors(...errors: unknown[]): void {
  console.error(...flattenErrors(...errors));
}

// log only the inner errors from AggregateErrors.
// Useful for cases where
export function logInnerErrors(error: unknown): void {
  if (error instanceof AggregateError && error.errors.length > 0) {
    console.error('Inner errors:', ...flattenErrors(...(error.errors as unknown[])));
  }
}

function flattenErrors(...errors: unknown[]): unknown[] {
  return errors.flatMap((error) => {
    if (error instanceof AggregateError) {
      return [error, ...flattenErrors(...(error.errors as unknown[]))];
    }
    return [error];
  });
}

// log formatted Error
export function logFormattedError(error: unknown): void {
  console.error(formatError(error));
}
